"use client"

import { clsx } from "clsx"
import NextImage from "next/image"
import { ArticleTeaserLink } from "@/components/Link/ArticleLink/ArticleTeaserLink.component"
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context"
import type { ArticleTeaserModel } from "@/services/api/content/models/article-teaser-model.types"
import { imageLoader } from "@/utilities/image/image-loader"

type ArticleTeaserImageProps = {
  readonly sourceSetSize?: string
  readonly hasImagePriority?: boolean
  readonly className?: string
  readonly testId?: string
  readonly article: ArticleTeaserModel
}

export function ArticleTeaserImage({
  hasImagePriority,
  sourceSetSize,
  className,
  testId,
  article,
}: ArticleTeaserImageProps) {
  const { serverUrl } = useImageConfiguration()

  const { supportingImage } = article.content

  if (!supportingImage) {
    return null
  }

  return (
    <ArticleTeaserLink
      article={article}
      className={clsx(
        "relative block h-full max-h-auto w-full overflow-hidden",
        className,
      )}
      position="img"
      testId={testId}
    >
      <NextImage
        alt={supportingImage.alternativeText}
        className="bg-whisper object-cover"
        fill={true}
        loader={imageLoader(serverUrl)}
        priority={hasImagePriority}
        sizes={sourceSetSize}
        src={supportingImage.aspectRatio3By2}
      />
    </ArticleTeaserLink>
  )
}
